exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "section.Cards {\n  -webkit-transition: all 0.75s;\n  -o-transition: all 0.75s;\n  transition: all 0.75s; }\n  section.Cards.Hide {\n    opacity: 0; }\n  section.Cards > .Text {\n    position: absolute;\n    top: -18px;\n    font-size: 14px;\n    font-weight: 200; }\n\nsection.PostRaceCards {\n  padding-top: 15px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Cards/SectionCards.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Cards/SectionCards.css
// module chunks = 0